/**
 * Format duration in seconds to human-readable string.
 *
 * Examples:
 * - 45 seconds → "45s"
 * - 90 seconds → "1m 30s"
 * - 3665 seconds → "1h 1m 5s"
 */

/**
 * Format duration in seconds to human-readable string.
 *
 * @param seconds - Total seconds elapsed
 * @returns Formatted duration string
 *
 * @example
 * formatDuration(45);     // "45s"
 * formatDuration(90);     // "1m 30s"
 * formatDuration(3665);   // "1h 1m 5s"
 * formatDuration(0);      // "0s"
 */
export function formatDuration(seconds: number): string {
  if (seconds < 0) return '0s';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }
  if (secs > 0 || parts.length === 0) {
    parts.push(`${secs}s`);
  }

  return parts.join(' ');
}

/**
 * Format relative time for "Started X ago" or "Completed X ago" displays.
 *
 * @param seconds - Total seconds elapsed
 * @returns Formatted relative time string
 *
 * @example
 * formatRelativeTime(45);   // "45s ago"
 * formatRelativeTime(154);  // "2m 34s ago"
 */
export function formatRelativeTime(seconds: number): string {
  return `${formatDuration(seconds)} ago`;
}
